module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/panel/panel-border-right-19.png"+" 19w",
        images: [{path: __webpack_public_path__ + "assets/images/panel/panel-border-right-19.png",width: 19,height: 305}],
        src: __webpack_public_path__ + "assets/images/panel/panel-border-right-19.png",
        toString: function(){return __webpack_public_path__ + "assets/images/panel/panel-border-right-19.png"},
        
        width: 19,
        height: 305
      }